module.exports = __webpack_public_path__ + "img/mini-app-qrcode.39262d7.png";